import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation, useNavigate } from 'react-router-dom';
import Loader from '../../components/Loader';
import { toast } from 'react-toastify';
import { InscriptionClientRequest } from '../../Api/AuthClient';
import Logo from '../../Image/logo.png';
import '../../Css/inscription.css';

const InscriptionClient = () => {
  const [showPass, setShowPass] = useState(false);
  const [showPassC, setShowPassC] = useState(false);

  const [nom, setNom] = useState('');
  const [prenom, setPrenom] = useState('');
  const [email, setEmail] = useState('');
  const [telephone, setTelephone] = useState('');
  const [password, setPassword] = useState('');
  const [cpassword, setCpassword] = useState('');
  const [accept, setAccept] = useState(false);
  const [loading, setLoading] = useState(false);

  let location = useLocation();
  let navigate = useNavigate();




  const handlePassword = () => setShowPass(!showPass);


  const handlePasswordC = () => setShowPassC(!showPassC);

  const [registerErrors, setRegisterErrors] = useState({
    nom: "",
    prenom: "",
    email: "",
    telephone: "",
    password: "",
    confirmPassword: "",
    check: "",
  });

  const handleNom = (e) => {
    setNom(e.target.value);
    setRegisterErrors((prevErrors) => ({
      ...prevErrors,
      nom: "",
    }));
  }

  const handlePrenom = (e) => {
    setPrenom(e.target.value);
    setRegisterErrors((prevErrors) => ({
      ...prevErrors,
      prenom: "",
    }));
  }

  const handleEmail = (e) => {
    const isValid = /^[a-zA-Z0-9\._\-]+@[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,4}$/.test(e.target.value);
    if (!isValid && e.target.value) {
      setRegisterErrors((prevErrors) => ({
        ...prevErrors,
        email: "La structure de votre e-mail n'est pas correcte.",
      }));
      setEmail(e.target.value);
    } else {
      setEmail(e.target.value);
      setRegisterErrors((prevErrors) => ({
        ...prevErrors,
        email: "",
      }));
    }
  }

  const handleTelephone = (e) => {
    const isValidNumeric = /^[0-9+]+$/.test(e.target.value);
    if (!isValidNumeric && e.target.value) {
      setRegisterErrors((prevErrors) => ({
        ...prevErrors,
        telephone: "Numérique uniquement",
      }));

    } else {
      setTelephone(e.target.value);
      setRegisterErrors((prevErrors) => ({
        ...prevErrors,
        telephone: "",
      }));
    }
  }

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    setRegisterErrors((prevErrors) => ({
      ...prevErrors,
      password: "",
    }));
  }

  const handleCPasswordChange = (e) => {
    setCpassword(e.target.value);
    if (password !== e.target.value) {
      setRegisterErrors((prevErrors) => ({
        ...prevErrors,
        confirmPassword: "Mot de passe doit-être égal a confirme mot de passe",
      }));
    } else {
      setRegisterErrors((prevErrors) => ({
        ...prevErrors,
        confirmPassword: "",
      }));
    }

  }

  const handleCheck = () => {
    setAccept(!accept);
    setRegisterErrors((prevErrors) => ({
      ...prevErrors,
      check: "",
    }));
  }

  const handleSubmit = (e) => {
    e.preventDefault();


    if (nom === "") {
      setRegisterErrors((prevErrors) => ({
        ...prevErrors,
        nom: "Nom obligatoire",
      }));
    } else if (nom.length < 2) {
      setRegisterErrors((prevErrors) => ({
        ...prevErrors,
        nom: "Caractère minimum 2",
      }));
    } else {
      setRegisterErrors((prevErrors) => ({
        ...prevErrors,
        nom: "",
      }));
    }


    if (prenom === "") {
      setRegisterErrors((prevErrors) => ({
        ...prevErrors,
        prenom: "Prenom obligatoire",
      }));
    } else if (prenom.length < 2) {
      setRegisterErrors((prevErrors) => ({
        ...prevErrors,
        prenom: "Caractère minimum 2",
      }));
    } else {
      setRegisterErrors((prevErrors) => ({
        ...prevErrors,
        prenom: "",
      }));
    }

    if (email === "") {
      setRegisterErrors((prevErrors) => ({
        ...prevErrors,
        email: "Email obligatoire",
      }));
    } else if (email.length < 2) {
      setRegisterErrors((prevErrors) => ({
        ...prevErrors,
        email: "Caractère minimum 2",
      }));
    } else {
      setRegisterErrors((prevErrors) => ({
        ...prevErrors,
        email: "",
      }));
    }

    if (telephone === "") {
      setRegisterErrors((prevErrors) => ({
        ...prevErrors,
        telephone: "Téléphone obligatoire",
      }));
    } else if (telephone.length < 3) {
      setRegisterErrors((prevErrors) => ({
        ...prevErrors,
        telephone: "Caractère minimum 3",
      }));
    } else {
      setRegisterErrors((prevErrors) => ({
        ...prevErrors,
        telephone: "",
      }));
    }

    if (password === "") {
      setRegisterErrors((prevErrors) => ({
        ...prevErrors,
        password: "Password obligatoire",
      }));
    } else if (password.length < 2) {
      setRegisterErrors((prevErrors) => ({
        ...prevErrors,
        password: "Caractère minimum 2",
      }));
    } else {
      setRegisterErrors((prevErrors) => ({
        ...prevErrors,
        password: "",
      }));
    }
    const isValidEmail = /^[a-zA-Z0-9\._\-]+@[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,4}$/.test(email);

    if (password !== cpassword) {
      toast.warning("Mot de passe doit-être égal a confirme mot de passe");
    } else {

      if (accept === true) {
        setRegisterErrors((prevErrors) => ({
          ...prevErrors,
          check: "",
        }));
        if (isValidEmail && nom !== "" && prenom !== "" && email !== "" && telephone !== "" && password !== "") {
          setLoading(true);
          const data = { nom: nom, prenom: prenom, email: email, telephone: telephone, password: password };
          InscriptionClientRequest(data).then(function (response) {
            console.log(response);
            if (response.data.title === "success") {
              toast.success(response.data.message);
              navigate('/loginClient');
            }
          }).catch(function (error) {
            console.log(error);
            if (error) {
              toast.error(error.response.data?.message);
            }
          }).finally(function () {
            setLoading(false);
          });
        }

      } else {
        setRegisterErrors((prevErrors) => ({
          ...prevErrors,
          check: "Vous devez accepter les conditions générales d’utilisation du site",
        }));
      }

    }
  }


  return (
    <div>
      <Helmet>
        <title>Inscription ~ Client</title>
        <meta name='description' content='Inscription client.' />
        <link rel='canonical' href={location.pathname} />
      </Helmet>
      <div className="inscription">
        {loading && <Loader />}
        <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-lx-12'>
          <div className="d-flex justify-content-center">
            <div className='col-12 col-sm-12 col-md-8 col-lg-6 col-xl-6'>

              <form onSubmit={handleSubmit}>
                <div className='bloc_inscription'>
                  <div className='d-flex justify-content-center'>
                    <div className='logo'>
                      <img src={Logo} alt="logo e-kaly" />
                    </div>
                  </div>
                  <h1 className='text-center'>Créer votre compte</h1>
                  <div className='row'>
                    <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                      <div className='form_1'>
                        <div>
                          <div className=" mb-3">
                            <label className="form-label">Nom</label>
                            <input type="text" className="form-control" value={nom} onChange={handleNom} placeholder="Nom ..." />
                            {registerErrors.nom !== "" ? <span className="text-danger"><small>({registerErrors.nom})</small></span> : ''}
                          </div>
                          <div className=" mb-3">
                            <label className="form-label">Prénom</label>
                            <input type="text" className="form-control" value={prenom} onChange={handlePrenom} placeholder="Prénom ..." />
                            {registerErrors.prenom !== "" ? <span className="text-danger"><small>({registerErrors.prenom})</small></span> : ''}
                          </div>
                          <div className="mb-3">
                            <label className="form-label">Adresse email</label>
                            <input type="email" className="form-control" value={email} onChange={handleEmail} placeholder="Adresse email ..." />
                            {registerErrors.email !== "" ? <span className="text-danger"><small>({registerErrors.email})</small></span> : ''}
                          </div>
                        </div>
                        <div className='description_form_1'>
                          <h2>Demande à l’attention du restaurant <span>(facultatif)</span></h2>
                          <div className='content_description'>
                            <span>Votre demande sera transmise au restaurant, mais nous ne pouvons vous garantir qu’il pourra satisfaire votre demande.</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                      <div className='form_2'>
                        <div>
                          <div className="mb-3">
                            <label className="form-label">Téléphone</label>
                            <input type="text" className="form-control" value={telephone} onChange={handleTelephone} placeholder="Téléphone ..." />
                            {registerErrors.telephone !== "" ? <span className="text-danger"><small>({registerErrors.telephone})</small></span> : ''}
                          </div>
                          <div className="mb-3">
                            <label className="form-label">Mot de passe</label>
                            <input type={showPass ? "text" : "password"} value={password} onChange={handlePasswordChange} className="form-control" placeholder="Mot de passe ..." />
                            <div className='d-flex justify-content-end'>
                              <i className={showPass ? 'fa fa-eye-slash' : 'fa fa-eye'} onClick={handlePassword} ></i>
                            </div>
                            {registerErrors.password !== "" ? <span className="text-danger"><small>({registerErrors.password})</small></span> : ''}
                          </div>

                          <div className=" mb-3">
                            <label className="form-label">Confimer mot de passe</label>
                            <input type={showPassC ? "text" : "password"} value={cpassword} onChange={handleCPasswordChange} className="form-control" placeholder="Confirmer mot de passe ..." />
                            <div className='d-flex justify-content-end'>
                              <i className={showPassC ? 'fa fa-eye-slash' : 'fa fa-eye'} onClick={handlePasswordC} ></i>
                            </div>
                            {registerErrors.confirmPassword !== "" ? <span className="text-danger"><small>({registerErrors.confirmPassword})</small></span> : ''}
                          </div>

                        </div>
                        <div className='condition_form_2'>
                          <div className="form-check">
                            <input className="form-check-input" type="checkbox" defaultValue id="flexCheckDefault1" />
                            <label className="form-check-label" htmlFor="flexCheckDefault1">
                              Je souhaite recevoir des <span>informations de la part de ce restaurant</span>.
                            </label>
                          </div>
                          <div className="form-check mt-2">
                            <input className="form-check-input" value={accept} onChange={handleCheck} type="checkbox" defaultValue id="flexCheckDefault2" />
                            <label className="form-check-label" htmlFor="flexCheckDefault2">
                              Je reconnais avoir pris <span className='danger'>connaissance</span> et <span className='danger'>accepter les conditions générales d’utilisation du site xxx</span>.
                            </label>
                            {registerErrors.check !== "" ? <span className="text-danger"><small>({registerErrors.check})</small></span> : ''}
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='d-flex justify-content-center'>
                    <button type="submit" className="btn btn_inscrire">Créer mon compte</button>
                  </div>
                  <p className="version">Version 1</p>
                </div>
              </form>

            </div>

          </div>
        </div>
      </div>
    </div>
  )
}

export default InscriptionClient